<template>
  <login-panel
    class="temporary-password"
    xs
  >
    <div class="temporary-password__content">
      <div class="temporary-password__icon">
        <img
          src="/static/imgs/temporary-password-created.png"
          alt=""
        >
      </div>
      <h3 class="temporary-password__title">
        {{ $t('login.temporary-password-created') }}
      </h3>
      <p class="temporary-password__description">
        {{ $t('login.temporary-password-text') }}
      </p>
      <input-copy-content
        class="temporary-password__pass-input"
        box-mode
        v-model="temporaryPassword"
        disabled
      />
      <router-link
        class="btn btn-primary btn-block temporary-password__go-to-login"
        :to="{ name: 'sign-in' }"
      >
        {{ $t('login.go-to-login-page') }}
      </router-link>
    </div>
  </login-panel>
</template>

<script>
import LoginPanel from '@/components/LoginPanel';
import InputCopyContent from '@/components/inputs/InputCopyContent';

export default {
  components: {
    LoginPanel,
    InputCopyContent,
  },
  computed: {
    temporaryPassword() {
      return this.$route.params.temporaryPassword;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.temporaryPassword) {
      next({ name: 'insert-user-data' });
    } else {
      next();
    }
  },
};
</script>

<style lang="sass" scoped>
.temporary-password
  &__content
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
  &__icon
    margin-top: 30px
  &__title
    font-weight: 600
    font-size: 1.1rem
    margin-top: 30px
    text-transform: uppercase
    text-align: center
  &__description
    text-align: center
    font-size: .9rem
    margin-top: 30px
  &__go-to-login
    font-weight: 600
    margin-top: 30px
    white-space: normal
  &__pass-input
    font-size: 2em
    width: 100%
</style>
